import Vue from 'vue';
import Router from 'vue-router';

import { AuthGuard } from '@/guards/auth-guard';
import { NonAuthGuard } from '@/guards/non-auth-guard';

Vue.use(Router);

export default new Router({
    //mode: 'history',
    routes: [

        // defaults
        { path: '/', redirect: { name: 'Hospitals' } },

        // hospitals               
        { path: '/hospitals', name: 'Hospitals', component: () => import('./views/Hospitals.vue'), beforeEnter: AuthGuard },
        { path: '/hospitals/:hospital', name: 'Hospital', component: () => import('./views/Hospital.vue'), beforeEnter: AuthGuard },
        { path: '/hospitals/:hospital/activity', name: 'Activity', component: () => import('./views/Activity.vue'), beforeEnter: AuthGuard },
        { path: '/hospitals/:hospital/tickets', name: 'Tickets', component: () => import('./views/Tickets.vue'), beforeEnter: AuthGuard },
        { path: '/hospitals/:hospital/systems', name: 'Systems', component: () => import('./views/Systems.vue'), beforeEnter: AuthGuard },
        { path: '/hospitals/:hospital/systems/:system/:tab?', name: 'System', component: () => import('./views/System.vue'), beforeEnter: AuthGuard },

        // account
        { path: '/login', name: 'Login', component: () => import('./views/Login.vue'), beforeEnter: NonAuthGuard },
        { path: '/reset-password/:token', name: 'ResetPasswordToken', component: () => import('./views/ResetPasswordToken.vue'), 
            beforeEnter: (to, from, next) => {
                localStorage.setItem('resetToken', to.params.token)
                next('/reset-password');
            }
        },
        { path: '/reset-password', name: 'ResetPassword', component: () => import('./views/ResetPassword.vue') },
        { path: '/change-password', name: 'ChangePassword', component: () => import('./views/ChangePassword.vue'), beforeEnter: AuthGuard },
        { path: '/reset-password-request', name: 'RemindPassword', component: () => import('./views/RemindPassword.vue'), beforeEnter: NonAuthGuard },

        // not found (404)
        { path: '*', redirect: '/' }

    ]
});
